import type { FC } from "react";

import { supportTicketReasonCategories } from "./supportTicketReasonCategories";
import { SupportCategorizedCheckboxList } from "../shared/SupportCategorizedCheckboxList";

type Props = {
  selectedReasonIds: string[];
  onSelectedReasonIdsChange: (selectedReasonIds: string[]) => void;
};

export const SupportTicketReasonPickerContent: FC<Props> = ({
  selectedReasonIds,
  onSelectedReasonIdsChange,
}) => {
  const categories = supportTicketReasonCategories.map((category) => ({
    id: category.id,
    label: category.label,
    options: category.options.map((option) => ({
      key: option.id,
      label: option.label,
    })),
  }));

  return (
    <div css={{ flex: 1, minHeight: 0, height: "100%", display: "flex", flexDirection: "column" }}>
      <SupportCategorizedCheckboxList
        categories={categories}
        selectedKeys={selectedReasonIds}
        onSelectedKeysChange={onSelectedReasonIdsChange}
      />
    </div>
  );
};
